var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body application-details-container"},[_c('div',{staticClass:"details"},[(_vm.showPrebuiltConfig)?_c('PreBuiltIdmConnectorConfig'):_c('GenericScimConnectorConfig',{attrs:{"showOauthConfigReloadModal":_vm.showOauthConfigReloadModal},on:{"closeConfigReloadModal":_vm.closeReloadConfigDecisionModal}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }